import { styled, Typography } from '@mui/material';

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  height: '100%',
  svg: {
    marginBottom: theme.spacing(2)
  }
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.neutral[900],
  fontWeight: 600
}));

export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.textColors[800],
  maxWidth: theme.spacing(70),
  textAlign: 'center'
}));
